module.exports = __webpack_public_path__ + "img/empty.cbaf8962.svg";